module.exports = __webpack_public_path__ + "img/132.91b65546.jpg";